export const OWNER = 'facebook';
export const REPO = 'react';
